import React from 'react';
import { Icon, Grid, Loader, Popup } from 'semantic-ui-react';
import { FilterableList } from 'dyl-components';

import { connect } from 'react-redux';
import { DateTimeUtils } from 'dyl-components';
import TasksTimeline from 'shared/TasksTimeline';

import usersActions from 'actions/users';
import taskTypesActions from 'actions/task_types';
import { Link } from 'react-router-dom';
import tasksActions from 'actions/tasks';

class Tasks extends React.Component {
    
    state = {
        isCollapsed: false,
        isAddModalOpen: false,
        isEditModalOpen: false,
        taskToBeEdited: null
    }
    componentDidMount() {
        this.props.onReadUsers();
        this.props.onReadTasks(this.props.contact_id);
    }

    onToggleCollapsed = () => {
        this.setState(prevState => ({
            isCollapsed: !prevState.isCollapsed
        }));
    }

    onChange = (_, { name, value }) => {
        this.setState({
            [name]: value
        })
    }

    onOpenEditModal = (task) => {
        this.setState({
            isEditModalOpen: true,
            taskToBeEdited: { date: DateTimeUtils.formatEpoch(task.ts, DateTimeUtils.DATE_FORMAT), time: DateTimeUtils.formatEpoch(task.ts), ...task }
        })
    }

    onCloseEditModal = () => {
        this.setState({
            isEditModalOpen: false
        })
    }

    render() {
        const contact_id = this.props.contact_id;
        return (
            <React.Fragment>
                <FilterableList
                    header={<React.Fragment>
                        <div><Popup
                            trigger={<Icon as={Link} to={`/contact/${contact_id}/tasks`} className='fas fa-plus-circle' link />}
                            content='Add Task'
                            inverted
                        /> Tasks
                        </div>
                        <Link to={`/contact/${contact_id}/tasks`}>
                            <span className='ViewAll'>
                                <b>View All</b>
                            </span>
                        </Link>
                    </React.Fragment>}
                    onToggleCollapsed={this.onToggleCollapsed}
                    listComponent={(
                        <Grid>
                            <Grid.Row>
                                <Grid.Column>
                                    <Loader active={this.props.isReadingTasks} />
                                    <TasksTimeline
                                        onOpenEditModal={this.onOpenEditModal}
                                    />
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    )}
                    isCollapsed={this.state.isCollapsed}
                />
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => {

    const contactEmails = state.contact.email ? state.contact.email.slice(0).map(({ email }) => email) : [];

    return {
        tasks: state.tasks.tasks,
        isReadingTasks: state.tasks.isReadingTasks || state.account.isReadingProfile,

        contactEmails,
        activeIntegration: state.email.activeIntegration,
        contact_id: state.contact.contact_id,
        account_id: state.contact.account_id || state.account.account_id
    }
};

const mapDispatchToProps = dispatch => ({
    onReadUsers: () => {
        dispatch(usersActions.readUsers());
    },
    onReadTaskTypes: () => {
        dispatch(taskTypesActions.readTaskTypes());
    },
    onReadTasks: (contact_id) => {
        dispatch(tasksActions.readTasks({ 
            contact_ids: [contact_id],
            limit: 5,
            deleted: false 
        }));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(Tasks)
